import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { ModuleType } from '../../../../types/modules';
import { getModuleIdByModuleType } from '../../../selectors/modules';
import { Props } from './InviteToGroupModal';

export type StateProps = Pick<Props, 'moduleId'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = state => ({
  moduleId: getModuleIdByModuleType(state, ModuleType.GROUP_RECRUITMENT),
});

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = () => ({});

export default connect(mapStateToProps, mapDispatchToProps);
